import './Header.css';
//import AccountMenu from "./AccountMenu/AccountMenu";
import {MainMenu} from "./MainMenu/MainMenu";
import React from "react";
import {disableMapDragging, enableMapDragging} from "../Map/MapEvents/MapEvents";

export function Header(props){
    return(
        <div onMouseDown={() => disableMapDragging(props.map)} onMouseUp={() => enableMapDragging(props.map)}>
            <header className="Header">
                <div>
                    <MainMenu map={props.map}/>
                </div>
                <div className="label">
                    <h1>ГИС «Мониторинг пожаров»</h1>
                </div>
                {/* <div className="account_menu">
                    <AccountMenu />
                </div> */}
            </header>
        </div>
    );
}